export enum CommandStatus {
    /**
     * Command awaiting execution. Possible transition PENDING -> [EXECUTED|REJECTED].
     */
    PENDING = 'PENDING',
     /**
     * Command executING. Possible transition EXECUTING -> EXECUTED
     */
    EXECUTING = 'EXECUTING',
    /**
     * Command executed. Possible transition EXECUTED -> REVERTED
     */
    EXECUTED = 'EXECUTED',
    /**
     * Executed command has been reverted. It is final state.
     */
    REVERTED = 'REVERTED',
    /**
     * Executed command has been rejected. It is final state.
     */
    REJECTED = 'REJECTED',
    /**
     * Command has been executed but an error occurred.
     */
    FAILED = 'FAILED'
}

export interface CommandDescriptor {
    id: number;
    type: string;
    simpleName: string;
    input: string;
    output: string;
    errorResponse: unknown;
    customerId: number;
    productId: number;
    branchId: number;
    executionDate: Date;
    requestUuid: string;
    status: CommandStatus;
    context: unknown;
    inputObject: unknown;
    outputObject: unknown;
    prints: CommandPrintOutput[];
    cmc: string;
    executedBy: number;
    approvedBy: number;
    rejectedBy: number;
    executionTime: Date;
    revertCommandId: number;
    ruleAttributes: unknown;
    registrationTime: Date;
}

export interface CommandPrintOutput {
    input: unknown;
    code: string;
    parameters: Record<string, unknown>;
}

export interface CommandOutputWrapper<T> {
    output: T;
    executionMode: CommandExecutionMode;
    approvalRequired: boolean;
    validationRequired: boolean;
    otpRequired: boolean;
    commandId: number;
    prints: CommandPrintOutput[];
}

export enum CommandExecutionMode {
    SYNC = 'SYNC',
    ASYNC = 'ASYNC'
}
